// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.youtube-linking-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
}

.youtube-linking-header {
  margin-bottom: 30px;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 20px;
}

.youtube-linking-header h1 {
  font-size: 2rem;
  font-weight: 600;
  margin: 10px 0;
  color: #1a1a1a;
}

.subtitle {
  color: #666;
  font-size: 1rem;
  margin: 0;
}

.back-button {
  background: none;
  border: 1px solid #ddd;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #555;
  transition: all 0.2s ease;
  margin-bottom: 15px;
}

.back-button:hover {
  background-color: #f5f5f5;
  border-color: #bbb;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 1.1rem;
}

.message {
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.message.success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.message.error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.dismiss-button {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 0;
  margin-left: 10px;
  opacity: 0.7;
}

.dismiss-button:hover {
  opacity: 1;
}

.languages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.language-card {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 20px;
  background: white;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.language-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  border-color: #d0d0d0;
}

.language-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 15px;
}

.language-info h3 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: #1a1a1a;
}

.language-code {
  font-size: 0.9rem;
  color: #666;
  background: #f8f9fa;
  padding: 2px 8px;
  border-radius: 4px;
}

.connected-state, .disconnected-state {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
}

.channel-info {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
}

.status-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}

.status-indicator.connected {
  background-color: #28a745;
  box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.2);
}

.status-indicator.disconnected {
  background-color: #dc3545;
  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.2);
}

.channel-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.channel-details strong {
  font-weight: 600;
  color: #1a1a1a;
}

.channel-link {
  color: #007bff;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s ease;
}

.channel-link:hover {
  color: #0056b3;
  text-decoration: underline;
}

.channel-details small {
  color: #666;
  font-size: 0.8rem;
}

.connect-button {
  background-color: #1a73e8;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.connect-button:hover:not(:disabled) {
  background-color: #1557b0;
  transform: translateY(-1px);
}

.connect-button:disabled {
  background-color: #9aa0a6;
  cursor: not-allowed;
  transform: none;
}

.disconnect-button {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.disconnect-button:hover {
  background-color: #c82333;
  transform: translateY(-1px);
}

.instructions {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 24px;
  border-left: 4px solid #1a73e8;
}

.instructions h3 {
  margin: 0 0 15px 0;
  color: #1a1a1a;
  font-size: 1.1rem;
}

.instructions ul {
  margin: 0 0 20px 0;
  padding-left: 20px;
}

.instructions li {
  margin-bottom: 8px;
  color: #555;
  line-height: 1.5;
}

.note {
  background: white;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  margin-top: 20px;
}

.note strong {
  color: #1a73e8;
}

.youtube-linking-button {
  background-color: #ff0000;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  margin-left: 12px;
}

.youtube-linking-button:hover {
  background-color: #cc0000;
  transform: translateY(-1px);
}

/* Channel Analytics Styles */
.channel-analytics {
  margin: 8px 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: #f8f9fa;
  border-radius: 6px;
  padding: 8px 10px;
  border-left: 3px solid #28a745;
}

.analytics-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
}

.analytics-item.highlight {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 4px 6px;
  margin: 2px 0;
}

.analytics-label {
  color: #666;
  font-weight: 500;
}

.analytics-value {
  color: #1a1a1a;
  font-weight: 600;
}

.analytics-value.unread-count {
  background: #ff6b6b;
  color: white;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 0.75rem;
  min-width: 18px;
  text-align: center;
}

.analytics-error {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px;
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 6px;
}

.error-icon {
  font-size: 1rem;
}

.error-text {
  color: #856404;
  font-size: 0.8rem;
  font-weight: 500;
}

.reconnect-button {
  background: #007bff;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  cursor: pointer;
  transition: background 0.2s ease;
  align-self: flex-start;
}

.reconnect-button:hover:not(:disabled) {
  background: #0056b3;
}

.reconnect-button:disabled {
  background: #6c757d;
  cursor: not-allowed;
}

/* Responsive design */
@media (max-width: 768px) {
  .languages-grid {
    grid-template-columns: 1fr;
  }
  
  .connected-state, .disconnected-state {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  
  .channel-info {
    justify-content: flex-start;
  }
  
  .youtube-linking-header h1 {
    font-size: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/YouTubeLinkingPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,gFAAgF;AAClF;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".youtube-linking-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n}\n\n.youtube-linking-header {\n  margin-bottom: 30px;\n  border-bottom: 1px solid #e0e0e0;\n  padding-bottom: 20px;\n}\n\n.youtube-linking-header h1 {\n  font-size: 2rem;\n  font-weight: 600;\n  margin: 10px 0;\n  color: #1a1a1a;\n}\n\n.subtitle {\n  color: #666;\n  font-size: 1rem;\n  margin: 0;\n}\n\n.back-button {\n  background: none;\n  border: 1px solid #ddd;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #555;\n  transition: all 0.2s ease;\n  margin-bottom: 15px;\n}\n\n.back-button:hover {\n  background-color: #f5f5f5;\n  border-color: #bbb;\n}\n\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n  font-size: 1.1rem;\n}\n\n.message {\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.message.success {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.message.error {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.dismiss-button {\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  padding: 0;\n  margin-left: 10px;\n  opacity: 0.7;\n}\n\n.dismiss-button:hover {\n  opacity: 1;\n}\n\n.languages-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 20px;\n  margin-bottom: 40px;\n}\n\n.language-card {\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  padding: 20px;\n  background: white;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.language-card:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n  border-color: #d0d0d0;\n}\n\n.language-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 15px;\n}\n\n.language-info h3 {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.language-code {\n  font-size: 0.9rem;\n  color: #666;\n  background: #f8f9fa;\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n.connected-state, .disconnected-state {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 15px;\n}\n\n.channel-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n}\n\n.status-indicator {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.status-indicator.connected {\n  background-color: #28a745;\n  box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.2);\n}\n\n.status-indicator.disconnected {\n  background-color: #dc3545;\n  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.2);\n}\n\n.channel-details {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.channel-details strong {\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.channel-link {\n  color: #007bff;\n  text-decoration: none;\n  font-size: 0.9rem;\n  transition: color 0.2s ease;\n}\n\n.channel-link:hover {\n  color: #0056b3;\n  text-decoration: underline;\n}\n\n.channel-details small {\n  color: #666;\n  font-size: 0.8rem;\n}\n\n.connect-button {\n  background-color: #1a73e8;\n  color: white;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.connect-button:hover:not(:disabled) {\n  background-color: #1557b0;\n  transform: translateY(-1px);\n}\n\n.connect-button:disabled {\n  background-color: #9aa0a6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.disconnect-button {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  padding: 8px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.disconnect-button:hover {\n  background-color: #c82333;\n  transform: translateY(-1px);\n}\n\n.instructions {\n  background: #f8f9fa;\n  border-radius: 12px;\n  padding: 24px;\n  border-left: 4px solid #1a73e8;\n}\n\n.instructions h3 {\n  margin: 0 0 15px 0;\n  color: #1a1a1a;\n  font-size: 1.1rem;\n}\n\n.instructions ul {\n  margin: 0 0 20px 0;\n  padding-left: 20px;\n}\n\n.instructions li {\n  margin-bottom: 8px;\n  color: #555;\n  line-height: 1.5;\n}\n\n.note {\n  background: white;\n  padding: 15px;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n  margin-top: 20px;\n}\n\n.note strong {\n  color: #1a73e8;\n}\n\n.youtube-linking-button {\n  background-color: #ff0000;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  margin-left: 12px;\n}\n\n.youtube-linking-button:hover {\n  background-color: #cc0000;\n  transform: translateY(-1px);\n}\n\n/* Channel Analytics Styles */\n.channel-analytics {\n  margin: 8px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  padding: 8px 10px;\n  border-left: 3px solid #28a745;\n}\n\n.analytics-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.85rem;\n}\n\n.analytics-item.highlight {\n  background: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 4px;\n  padding: 4px 6px;\n  margin: 2px 0;\n}\n\n.analytics-label {\n  color: #666;\n  font-weight: 500;\n}\n\n.analytics-value {\n  color: #1a1a1a;\n  font-weight: 600;\n}\n\n.analytics-value.unread-count {\n  background: #ff6b6b;\n  color: white;\n  padding: 2px 6px;\n  border-radius: 10px;\n  font-size: 0.75rem;\n  min-width: 18px;\n  text-align: center;\n}\n\n.analytics-error {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 8px;\n  background: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 6px;\n}\n\n.error-icon {\n  font-size: 1rem;\n}\n\n.error-text {\n  color: #856404;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.reconnect-button {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  cursor: pointer;\n  transition: background 0.2s ease;\n  align-self: flex-start;\n}\n\n.reconnect-button:hover:not(:disabled) {\n  background: #0056b3;\n}\n\n.reconnect-button:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .languages-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .connected-state, .disconnected-state {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n  \n  .channel-info {\n    justify-content: flex-start;\n  }\n  \n  .youtube-linking-header h1 {\n    font-size: 1.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
